var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 1.75C1.5 1.61193 1.61193 1.5 1.75 1.5H12.25C12.3881 1.5 12.5 1.61193 12.5 1.75V12.25C12.5 12.3881 12.3881 12.5 12.25 12.5H1.75C1.61193 12.5 1.5 12.3881 1.5 12.25V1.75ZM1.75 0C0.7835 0 0 0.7835 0 1.75V12.25C0 13.2165 0.7835 14 1.75 14H12.25C13.2165 14 14 13.2165 14 12.25V1.75C14 0.7835 13.2165 0 12.25 0H1.75ZM10.7803 5.28033C11.0732 4.98744 11.0732 4.51256 10.7803 4.21967C10.4874 3.92678 10.0126 3.92678 9.7197 4.21967L5.75 8.18934L4.28033 6.71967C3.98744 6.42678 3.51256 6.42678 3.21967 6.71967C2.92678 7.01256 2.92678 7.48744 3.21967 7.78033L5.21967 9.7803C5.51256 10.0732 5.98744 10.0732 6.28033 9.7803L10.7803 5.28033Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCheckbox);
export default __webpack_public_path__ + "static/media/whiteCheckbox.c8edbd8789476a86ec0b6f8ac6b78981.svg";
export { ForwardRef as ReactComponent };